module.exports = __webpack_public_path__ + "img/selected4-min.c4276dc0.png";